import React, { act, useCallback, useEffect, useMemo, useState } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as FilterIcon } from "../../../assets/svgs/filter-icon.svg";
import { Badge } from "../../../components/Elements/TextStyles/Badge";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import dayjs from "dayjs";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import CustomerSupportTicketFilter from "./Roles/DIalogBoxes/CustomerSupportTicketFilter";

const CustomerSupportTickets = ({ clientId }) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const pageSize = 10;
  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Ticket ID", key: "ticketId" },
      { label: "Created On", key: "createdOn" },
      { label: <div className="px-10">Status</div>, key: "status" },
      { label: "Action", key: "action" },
    ],
    []
  );

  // const staticData = useMemo(
  //   () => [
  //     {
  //       key: 1,
  //       serial: 1,
  //       sectionName: "John Doe",
  //       createdOn: "10/01/25",
  //       status: <Badge text="Closed" />,
  //       action: (
  //         <div className="flex gap-3">
  //           <EyeIcon />
  //         </div>
  //       ),
  //     },
  //     {
  //       key: 2,
  //       serial: 2,
  //       sectionName: "Dipesh",
  //       createdOn: "10/01/25",
  //       status: <Badge text="Open" />,
  //       action: (
  //         <div className="flex gap-3">
  //           <EyeIcon />
  //         </div>
  //       ),
  //     },
  //     {
  //       key: 3,
  //       serial: 3,
  //       sectionName: "Nitesh",
  //       createdOn: "10/01/25",
  //       status: <Badge text="In-Process" />,
  //       action: (
  //         <div className="flex gap-3">
  //           <EyeIcon />
  //         </div>
  //       ),
  //     },
  //   ],
  //   []
  // );

  const fetchTableData = useCallback(
    async (page = 1, status) => {
      try {
        setLoading(true);
        console.log("checkedItems", status);
        const response = await getApi({
          apiUrl: API_URLS.ALL_TICKETS(page, pageSize, status, searchTerm),
        });
        if (response.success) {
          const pageData = response.data.tickets.map((item, index) => ({
            key: item._id,
            serial: <div className="text-center">{index + 1}</div>,
            ticketId: (
              <div className="text-center justify-center items-center">
                {item._id}
              </div>
            ),
            status: (
              <div className="flex justify-center">
                <Badge text={item.status} />
              </div>
            ),
            createdOn: <div>{dayjs(item.createdAt).format("DD/MM/YYYY")}</div>,
            action: (
              <div className="justify-center items-center flex">
                <GreenEye
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#0087A3",
                  }}
                  className="w-4 h-4 sm:w-5 sm:h-5"
                  onClick={() => navigate(`/support-ticket/chat/${item._id}`)}
                />
              </div>
            ),
          }));

          setTickets(pageData);
          setTotal(response.data.pagination?.totalDocs || 0);
        } else {
          setTickets([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching static pages:", error);
        setTickets([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm, navigate]
  );

  // const fetchGroups = async () => {
  //   try {
  //     const response = await getApi({
  //       apiUrl: API_URLS.ALL_CUSTOMER_TICKETS,
  //       headers: { client: clientId },
  //     });
  //     if (response.success) {
  //       setTablecData(
  //         response.data.tickets.map((ticket, index) => ({
  //           serial: index + 1,
  //           TicketId: ticket._id,
  //           createdOn: dayjs(ticket.createdAt).format("DD/MM/YYYY"),
  //           status: (
  //             <div className="flex justify-center">
  //               {" "}
  //               <Badge text={ticket.status} />{" "}
  //             </div>
  //           ),
  //           action: (
  //             <div>
  //               <GreenEye />
  //             </div>
  //           ),
  //         }))
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error is fetching Tickets Tables", error);
  //   }
  //   // setTablecData(staticData);
  // };

  useEffect(() => {
    fetchTableData(pageNo, status);
  }, [pageNo, status, searchTerm]);

  useEffect(() => {
    const savedPage = sessionStorage.getItem("customerSupportTicketPage");
    if (savedPage) {
      setPageNo(parseInt(savedPage, 10));
    }
  }, []);

  const filteredData = useMemo(() => {
    let data = [...tickets];
    return data;
  }, [tickets]);
  return (
    <div
      style={{paddingLeft:"40px",paddingRight:"40px",paddingTop:"20px"  }}
    >
      <CardsBorder>
        <div className="flex justify-between">
          <div className="flex gap-8 my-4 font-medium">
            <p className="text-[#06513D] pt-2 px-10 text-xl">Support Tickets</p>
            <SearchBar width="300px" onSearch={setSearchTerm} />
          </div>
          <div className="mr-10">
            <Button
              onClick={() => setFilterOpen(true)}
              style={{ background: "#B6D4D9", border: "solid 1px #06513D" }}
              className="text-[12px] text-[#06513D] font-light px-4 py-5"
              // onClick={() => setFilterOpen(true)}
            >
              <FilterIcon /> FILTER
            </Button>
          </div>
        </div>
        <Tables
          headers={headers}
          data={filteredData}
          pageSize={pageSize}
          current={pageNo}
          total={total}
          loading={loading}
          onChange={(page) => {
            setPageNo(page);
            sessionStorage.setItem("customerSupportTicketPage", page.toString());
          }}
        />
      </CardsBorder>
      {filterOpen && (
        <CustomerSupportTicketFilter
          onOpen={filterOpen}
          onClose={() => setFilterOpen(false)}
          setStatus={setStatus}
        />
      )}
    </div>
  );
};

export default CustomerSupportTickets;
